export function overviewProjectionQueryKey(tenantId: string | null | undefined) {
  return ["graph-overview-projection", tenantId ?? "unauthenticated"] as const;
}
